"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dateValid = void 0;
const utils_1 = require("../utils");
const dateValid = (date) => {
    if (typeof date !== "string")
        return false;
    const parsedDate = new Date(date);
    return (0, utils_1.isValid)(parsedDate);
};
exports.dateValid = dateValid;
